// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/UserProjectService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { IdentityUserProjectModificationDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { IdentityUserDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/UserProjectService.proto.
 */
export const file_Services_UserProjectService: GenFile = /*@__PURE__*/
  fileDesc("CiFTZXJ2aWNlcy9Vc2VyUHJvamVjdFNlcnZpY2UucHJvdG8ykQUKElVzZXJQcm9qZWN0U2VydmljZRK0AgoQQWRkVXNlclRvUHJvamVjdBJALnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuSWRlbnRpdHlVc2VyUHJvamVjdE1vZGlmaWNhdGlvbkR0bxo4LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuSWRlbnRpdHlVc2VyRGV0YWlsZWREdG8iowGg2s0PAILT5JMClwFaJjoBKiIhL2FwaS91c2VyUHJvamVjdC9hZGRVc2VyVG9Qcm9qZWN0Gm0vYXBpL3VzZXJQcm9qZWN0L2FkZFVzZXJUb1Byb2plY3Qve3VzZXJfaWQuaGlnaF82NH0ve3VzZXJfaWQubG93XzY0fS97cHJvamVjdF9pZC5oaWdoXzY0fS97cHJvamVjdF9pZC5sb3dfNjR9EsMCChVSZW1vdmVVc2VyRnJvbVByb2plY3QSQC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLklkZW50aXR5VXNlclByb2plY3RNb2RpZmljYXRpb25EdG8aOC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLklkZW50aXR5VXNlckRldGFpbGVkRHRvIq0BoNrNDwCC0+STAqEBWis6ASoiJi9hcGkvdXNlclByb2plY3QvcmVtb3ZlVXNlckZyb21Qcm9qZWN0KnIvYXBpL3VzZXJQcm9qZWN0L3JlbW92ZVVzZXJGcm9tUHJvamVjdC97dXNlcl9pZC5oaWdoXzY0fS97dXNlcl9pZC5sb3dfNjR9L3twcm9qZWN0X2lkLmhpZ2hfNjR9L3twcm9qZWN0X2lkLmxvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Detailed, file_Options_MethodOptions]);

/**
 * Operations for mapping Identity users to projects.
 *
 * @generated from service UserProjectService
 */
export const UserProjectService: GenService<{
  /**
   * Add the user with the contained id to the project with the contained id.
   *
   * @generated from rpc UserProjectService.AddUserToProject
   */
  addUserToProject: {
    methodKind: "unary";
    input: typeof IdentityUserProjectModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Remove the user with the contained id from the project with the contained id.
   *
   * @generated from rpc UserProjectService.RemoveUserFromProject
   */
  removeUserFromProject: {
    methodKind: "unary";
    input: typeof IdentityUserProjectModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_UserProjectService, 0);

